export default "__VITE_ASSET__D9ZN8Rhg__"